import axios from "axios";
import { tokenConfig } from "./auth";
import swal from "sweetalert";

import {
  GET_COMMON_SUPPLIERS,
  ADD_COMMON_SUPPLIER,
  UPDATE_COMMON_SUPPLIER,
  SELECT_COMMON_SUPPLIER,
  DELETE_COMMON_SUPPLIER,
} from "./types";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// GET SUPPLIERS
export const getSuppliers = () => (dispatch, getState) => {
  axios
    .get(BASE_URL + `/common-material-suppliers`, tokenConfig(getState))
    .then((res) => {
      dispatch({
        type: GET_COMMON_SUPPLIERS,
        payload: res.data,
      });
    })
    .catch((err) => console.error(err));
};

// ADD SUPPLIER
export const addSupplier = (supplier) => (dispatch, getState) => {
  axios
    .post(
      BASE_URL + `/common-material-suppliers`,
      supplier,
      tokenConfig(getState)
    )
    .then((res) => {
      dispatch({
        type: ADD_COMMON_SUPPLIER,
        payload: res.data,
      });
      swal({
        title: "Supplier Added",
        icon: "success",
      });
    })
    .catch((err) => console.error(err));
};

// UPDATE SUPPLIER
export const updateSupplier = (id, supplier) => (dispatch, getState) => {
  axios
    .put(
      BASE_URL + `/common-material-suppliers/${id}`,
      supplier,
      tokenConfig(getState)
    )
    .then((res) => {
      dispatch({
        type: UPDATE_COMMON_SUPPLIER,
        payload: res.data,
      });
      swal({
        title: "Supplier Updated",
        icon: "success",
      });
    })
    .catch((err) => console.error(err));
};

// SELECT SUPPLIER
export const selectSupplier = (supplier) => (dispatch) => {
  dispatch({
    type: SELECT_COMMON_SUPPLIER,
    payload: supplier,
  });
};

// DELETE SUPPLIER
export const deleteSupplier = (id) => (dispatch, getState) => {
  axios
    .delete(
      BASE_URL + `/common-material-suppliers/${id}`,
      tokenConfig(getState)
    )
    .then((res) => {
      dispatch({
        type: DELETE_COMMON_SUPPLIER,
        payload: id,
      });
      swal({
        title: "Supplier Deleted!",
        icon: "success",
      });
    })
    .catch((err) => console.error(err));
};
